<template>
  <CardSingleLayout @click.native="openCard" :id="`card-${card.id}`" :class="cardSlotClass">
    <!-- notifications -->
    <template v-if="card.notifications" #notifications>
      <CardSingleNotifications :active="card.notifications" />
    </template>
    <!-- header -->
    <template v-if="card.title" #body-header>
      <CardHeader :card="card" />
    </template>
    <!-- details -->
    <template #body-details>
      <CardSingleBadges :card="card" />
      <CardUsers v-if="card.users" :users="card.users" ellipsis />
    </template>
    <!-- footer -->
    <template #footer>
      <CardSingleCompany v-if="card.account" :account="card.account" />
      <CardSingleStatus
        v-if="card.status !== 'active'"
        :status="card.status"
        :date="getStatusDate"
      />
    </template>
  </CardSingleLayout>
</template>

<script>
// Utilities
import { getSlotClass } from 'Utils'
import { getCardTitleSlug } from '../common/helpers'
import { getCardModalPageName } from 'Router/helpers'
// Components
import CardUsers from 'Components/CardUsers'
import CardHeader from 'Modules/Card/common/components/CardHeader'
import CardSingleLayout from 'Layouts/CardSingleLayout'
import CardSingleStatus from 'Components/CardSingleStatus'
import CardSingleBadges from './components/CardSingleBadges'
import CardSingleCompany from './components/CardSingleCompany'
import CardSingleNotifications from 'Components/CardSingleNotifications'

export default {
  name: 'CardSingle',

  props: {
    card: {
      type: Object,
      required: true,
    },
  },

  components: {
    CardUsers,
    CardHeader,
    CardSingleStatus,
    CardSingleLayout,
    CardSingleCompany,
    CardSingleNotifications,
    CardSingleBadges,
  },

  methods: {
    async openCard(event) {
      // if it's a link, we dont want to run this function
      if (
        event.target.nodeName.toLowerCase() === 'a' ||
        event.target.classList.contains('app-link')
      )
        return

      const cardTitle = getCardTitleSlug(this.card.title)
      const openRoute = getCardModalPageName()

      // if the card load is correct, we redirect to the page
      this.$router.push({
        name: openRoute,
        params: { card_id: this.card.id, card_title: cardTitle },
      })
    },
  },

  computed: {
    cardSlotClass() {
      return getSlotClass(this.card.slots)
    },

    getStatusDate() {
      return this.card.status !== 'active' ? this.card.status_changed : this.card.created
    },
  },
}
</script>

<style scoped></style>
